import React from "react";
import TabbedHub from "@/components/TabbedHub";
import Projects from "@/pages/Projects";
import ReviewsAndApprovals from "@/pages/ReviewsAndApprovals";
import Goals from "@/pages/Goals";
import Timesheet from "@/pages/Timesheet";
import Attendance from "@/pages/Attendance";
import usePermissions from "@/lib/usePermissions";
import { FolderKanban, CheckCircle2, Target, ClipboardList, Clock } from "lucide-react";

export default function MyWork() {
  const can = usePermissions();

  // Feb 2026 — Weekly Reports moved out of this hub into a per-project
  // "Weekly Report" section on each project's page (see ProjectDetail.jsx +
  // ProjectWeeklyReportSection.jsx), anchored to that project's scope.
  const tabs = [
    { id: "projects",   label: "Projects",            icon: FolderKanban,  render: () => <Projects />,            hidden: !can("my_work_projects") },
    { id: "reviews",    label: "Approvals",           icon: CheckCircle2,  render: () => <ReviewsAndApprovals />, hidden: !can("my_work_reviews") },
    { id: "goals",      label: "Goals",               icon: Target,        render: () => <Goals />,               hidden: !can("my_work_goals") && !can("personal_goals") },
    { id: "timesheet",  label: "Timesheet",           icon: ClipboardList, render: () => <Timesheet />,           hidden: !can("my_work_timesheet") },
    { id: "attendance", label: "Attendance",          icon: Clock,         render: () => <Attendance />,          hidden: !can("my_work_attendance") },
  ];

  return <TabbedHub hubKey="my-work" tabs={tabs} />;
}
